<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <template v-if="isDataAvailable === true">
                <div class="container-fluid xyz">
                    <div class="page-header-top-container">
                        <div class="page-name color-71aa3f">
                            {{ LabelName('callsemaillabel') }} Information <span class="badge badge-info">{{formatString(CallArr[0].direction)}}</span>
                        </div>
                        <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backShowCall">Back</button>
                    </div>
                    <div class="admin-page-content">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <b-list-group>
                                    <template v-for="(callData , key) in CallArr">
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Collector : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{callData.user_firstname + " " + callData.user_lastname}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Subject : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">
                                                        <template v-if="CallArr[0].call_type == 'dunning_notice'">
                                                            {{"Acct#" + callData.cusid + " : Dunning Notice"}}
                                                        </template>
                                                        <template v-else>
                                                            {{callData.subject}}
                                                        </template>
                                                    </span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Contact : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class=""><template v-if="callData.contact_first_name == ''">No Name </template><template v-else>{{callData.contact_first_name}} </template><template v-if="callData.contact_last_name == ''"></template><template v-else>{{callData.contact_last_name}} </template>(<template v-if="callData.email_1 != ''">{{callData.email_1}}</template><template v-else-if="callData.email_2 != ''">{{callData.email_2}}</template><template v-else-if="callData.phone_1 != ''">{{mobilenumber(mobilenumber(callData.phone_1,3,'-'),7,'-')}}</template><template v-else>{{mobilenumber(mobilenumber(callData.phone_2,3,'-'),7,'-')}}</template>)</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Type : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{formatString(callData.call_type)}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Additional Comments : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 noteContainer">
                                                    <span class="displayNotes" v-html="callData.notes"></span>
                                                    <!--<br>
                                                    <br>
                                                    <br>
                                                    <pre class="" v-html="callData.notes"></pre>-->
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                    </template>
                                </b-list-group>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <b-list-group>
                                    <template v-for="(callData , key) in CallArr">
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Created By : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{callData.created_firstname + " " + callData.created_lastname}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Customer : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{callData.first_name}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Priority : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{formatString(callData.priority)}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Call Date : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{formatDate(callData.call_date_time)}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Last Updated By : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{callData.updated_firstname + " " + callData.updated_lastname}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                    </template>
                                </b-list-group>
                            </div>
                        </div>
                    </div>
                    <template v-if="CallArr[0].call_type == 'dunning_notice'">
                        <div class="page-header-top-container pt-0">
                            <div class="page-name color-71aa3f">
                                Dunning notice email
                            </div>
                        </div>
                        <template v-for="(DunningData, index) in CallArr[0].dunning_datas">
                            <div class="admin-page-content">
                                <div class="forms-container">

                                    <div class="row">
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <p class="active"><strong>Subject : </strong>{{DunningData.subject}}</p>
                                        </div>
                                        <div style="overflow: auto;" class="col-xl-12 col-lg-12 col-md-12 col-sm-12" v-html="DunningData.dunning_data"></div>
                                        <template v-if="Attachments[index].length > 0">
                                            <div class="clearfix"></div>
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <p class="active"><strong>Attachments</strong></p>
                                                <template v-for="(AttachFile , key) in Attachments[index]">
                                                    <button class="btn edit-general-button btn-vvg waves-effect" type="button" v-on:click.prevent="downloadAttachmentFile(AttachFile)" target="_blank">{{getAttachmentFileName(AttachFile)}}</button>
                                                    <!--<a class="btn edit-general-button btn-vvg waves-effect"  :href="AttachFile" target="_blank">{{getAttachmentFileName(AttachFile)}}</a>-->
                                                </template>
                                            </div>
                                        </template>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </div>
            </template>
            <template v-else>
                <div class="admin-page-content">
                    <div class="col-md-12 error-detail-main forms-container">
                        <div class="error-template">
                            <!--<h1>Oops!</h1>-->
                            <h2>404</h2>
                            <div class="error-details">Data not available.</div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>   
</template>
<script>
    import Vue from 'vue';
    import FrontFooter from '@/components/partials/FrontFooter';
    import VeeValidate from 'vee-validate';
    import EventBus from '../event-bus';
    import SessioMixin from '../../mixins/sessionmixin';
    Vue.use(VeeValidate);
    export default {
        name: 'CaseView',
        components: {
            'app-footer': FrontFooter,
        },
        mixins: [SessioMixin],
        data() {
            return{
                isDataAvailable: true,
                isLoggedIn: false,
                permissions: [],
                cantAccessPage: true,
                CallArr: [[]],
                Attachments: [],
                commentsArr: [],
                comment: '',
                editId: '',
                loginID: 0,
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            $(".removeActive").removeClass('active');
            if (segments[4] != 0) {
                $("#menucustomers").addClass("active");
            } else {
                $("#menucalls").addClass('active');
            }
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            self.showLoader();
            self.loadCall();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                //console.log(self.loginID);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
            self.getAttachmentFileName('http://vvg.crm.com/api/invoices/XA410009278:01.pdf');

        },
        methods: {
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_calls_view') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            getAttachmentFileName: function (name) {
                return name.replace(process.env.ROOT_API.replace('/v1', '/invoices/'), '');
            },
            downloadAttachmentFile: function (name) {
                var self = this;

                var invoice = name.replace(process.env.ROOT_API.replace('/v1', '/invoices/'), '');
                invoice = invoice.replace('.pdf', '');
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/call/invoicepath",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        invoice: invoice,
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        if (data.status == "success") {
                            var win = window.open(data.content, '_blank');
                            if (win) {
                                //Browser has allowed it to be opened
                                win.focus();
                            } else {
                                //Browser has blocked it
                                alert('Please allow popups for this website');
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            loadCall() {
                var path = window.location.pathname;
                var segments = path.split("/");
                // console.log(segments[3]);
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/call/view/" + segments[3],
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    // dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        // console.log(data);
                        self.isDataAvailable = true;
                        self.CallArr = data;
                        self.Attachments = [];
                        $.each(data[0].dunning_datas, function (i) {
                            if(data[0].dunning_datas[i].attachment != null && data[0].dunning_datas[i].attachment != undefined){
                                var attach = JSON.parse(data[0].dunning_datas[i].attachment);
                                var attach = Object.keys(attach).map(function (k) {
                                    return attach[k]
                                });
                                let attachmentsArr = [];
                                $.each(attach, function (j) {
                                    //console.log(process.env.ROOT_API.replace('/v1', '') + '/' + attach[i]);
                                    attachmentsArr.push(process.env.ROOT_API.replace('/v1', '') + '/' + attach[j]);
                                });
                                self.Attachments.push(attachmentsArr);
                            }
                        });
                        //console.log(self.Attachments);
                        // console.log(self.CallArr);

                    },
                    error: function (jqXHR, exception) {
                        self.isDataAvailable = false;
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            backShowCall() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[4] != 0) {
                    self.$router.push("/customer/view/" + segments[4]);
                } else {
                    self.$router.push('/listcall');
                }
            },
            formatString(data) {
                if (typeof (data) != 'undefined') {
                    var self = this;
                    if (data == 'email') {
                        return 'E-Mail';
                    }
                    var value = data.replace(/_/g, " ");
                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;
                } else {
                    return false;
                }
            },
            formatDate(date) {
                if (typeof (date) != 'undefined') {
                    date = date.split(" ");
                    date = date[0];
                    var d = new Date(date);
                    var month = '' + (d.getMonth() + 1);
                    var day = '' + d.getDate();
                    var year = d.getFullYear();
                    if (month.length < 2)
                        month = '0' + month;
                    if (day.length < 2)
                        day = '0' + day;
                    return [month, day, year].join('/');
                } else {
                    return false;
                }
            },
            mobilenumber(string, position, addstring) {
                if (typeof (string) != 'undefined') {
                    if ($.trim(string) === "" && string.length <= 0) {
                        return string;
                    } else {
                        return [string.slice(0, position), addstring, string.slice(position)].join('');
                    }
                } else {
                    return false;
                }
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/callsAndEmails/CallsView.vue